import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { contractQueries } from '@/entities/contract'
import { isHttpError } from '@/shared/api'
import { useServerErrorHandler } from '@/shared/config'

export const useGetReceiptBillUrl = () => {
  const [isLoading, setIsLoading] = useState(false)

  const queryClient = useQueryClient()
  const { handleServerError } = useServerErrorHandler()

  const getReceiptBillUrl = async (contractId: number) => {
    setIsLoading(true)

    try {
      const res = await queryClient.fetchQuery({
        ...contractQueries.guestReceiptBillUrl({ contractId }),
        meta: {
          useCustomHandling: true,
        },
      })

      return {
        response: res,
        error: null,
      }
    } catch (error) {
      if (isHttpError(error)) {
        handleServerError(error.handler)
      }

      return {
        response: null,
        error,
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { getReceiptBillUrl, isLoading }
}
